// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ServicePointsTable--next-sr-only--CdOjwJy","formTitle":"ServicePointsTable--formTitle--3qFY7kq","submitButton":"ServicePointsTable--submitButton--2Jl-jr8"};